import { CLIENT_TIERS, type ClientTier, UNCATEGORIZED_LABEL } from "@klarity/schema";

/** One section of the Clients page. `none`: the clients without a tier. */
export type TierGroup<C> = { key: ClientTier | "none"; label: string; clients: C[] };

/**
 * The clients under their tiers, in the order of `CLIENT_TIERS`, then Uncategorized. A tier without clients
 * has no group. Inside a group the order is the one the clients came in (the server's: by name). A tier this
 * build does not know counts as none, so a client is always on the page.
 */
export function groupByTier<C extends { tier: ClientTier | null }>(clients: readonly C[]): TierGroup<C>[] {
  const groups: TierGroup<C>[] = CLIENT_TIERS.map((t) => ({
    key: t.key,
    label: t.label,
    clients: clients.filter((c) => c.tier === t.key),
  }));
  const known = new Set<string>(CLIENT_TIERS.map((t) => t.key));
  groups.push({
    key: "none",
    label: UNCATEGORIZED_LABEL,
    clients: clients.filter((c) => c.tier === null || !known.has(c.tier)),
  });
  return groups.filter((g) => g.clients.length > 0);
}
